module.exports = __webpack_public_path__ + "img/flags.9c74e172.9c74e172.png";